// extracted by mini-css-extract-plugin
export default {"options_row":"ReturnOptions_options_row__ateQe","option_wrapper":"ReturnOptions_option_wrapper__C4Mea"};